// ============================================================================
// RADIX SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'radix-sort',
  name: 'Radix Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(nk)',
    space: 'O(n + k)'
  },
  description: 'A non-comparison-based sorting algorithm that sorts numbers by processing individual digits. It processes digits from least significant to most significant, using a stable sorting algorithm (like counting sort) as a subroutine for each digit position.'
};
